// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor-module__anchor__40FY+","content":"Anchor-module__content__b4oFl"};